export default __webpack_public_path__ + "static/media/IMG-20250105-WA0027.b16c0bec.jpg";